// Module
var code = " <span ng-repeat=\"item in items\"> <input id=\"buttonset{{id}}{{$index}}\" type=\"radio\" value=\"{{item[value]}}\" name=\"{{id}}\" ng-disabled=\"ngDisabled\"> <label id=\"button-label-{{item[value]}}\" for=\"buttonset{{id}}{{$index}}\" class=\"radiobuttonset\">{{item[label]}}</label> </span> ";
// Exports
module.exports = code;